module.exports = __webpack_public_path__ + "img/bonus-prohibited.37e2ffd1.svg";